import { createSelector } from 'reselect';

import type { MayBe } from 'modules/global/typing/common/common';
import { getState as getParent, getFilters } from 'modules/guidelines/selectors/ui/dashboard';
import { getDealerDefaultLanguage, getSelectedDealerId, getSelectedDealerGroupId } from 'selectors/dealerSelectors';

const getState = createSelector(getParent, state => state.dealer);

export const getGuidelineIds = createSelector(getState, state => state.ids);

export const isLoading = createSelector(getState, state => state.loading);

export const getApiError = createSelector(getState, state => state.error);

export const hasError = createSelector(getApiError, error => error !== null);

export const getPage = createSelector(getState, state => state.page);

export const getSort = createSelector(getState, state => state.sort);

export const getParams = createSelector(
  getFilters,
  getSelectedDealerId,
  getSelectedDealerGroupId,
  getPage,
  getSort,
  getDealerDefaultLanguage,
  (filters, dealerId: MayBe<string>, groupId: MayBe<string>, { size }, sort, language: MayBe<string>) => ({
    ...filters,
    dealerId,
    groupId,
    sort,
    size,
    language,
  })
);
